<template>
    <div class="VueTables__columns-dropdown-wrapper w-100">

        <div :class="`${props.theme.dropdown.container} ${props.theme.right} VueTables__columns-dropdown w-100`">
            <button type="button" :class="`${props.theme.dropdown.trigger} col-12 btn btn-primary waves-effect waves-light float-right`"
                    @click="props.toggleColumnsDropdown">
                <i class="fas fa-columns mr-2"></i> Սյունակներ 
                <span :class="`${props.theme.icon} ${props.theme.small}`">
                    <i :class="props.theme.dropdown.caret"></i>
               </span>
            </button>
            <ul class="columns-list" :style="props.displayColumnsDropdown ?'display:block':'display:none'">
                <li v-bind:key="column" v-for="column in props.origColumns">
                    <a :class="props.theme.dropdown.item"
                       href="#"
                       @click="handleColumnSelect(column)">
                        <input type="checkbox" :value="column"
                               :disabled="props.onlyColumn(column)"
                               :checked="props.columns.includes(column)"/>
                        {{props.getHeading(column)}}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style scoped>
.btn-primary{
    margin-bottom: 20px;
}
.columns-list{
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 4px 0;
    margin: .125rem 0 0;
    font-size: .845rem;
    color: #303e67;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,0.05);
    border-radius: .25rem;
    box-shadow: 0 3px 12px rgba(214,228,241,0.3);
    margin: 0;
}
</style>

<script>
    export default {
        name: "MyColumnsDropdown",
        props: ['props'],
        methods: {
            handleColumnSelect(column){
                const selectedColumns = [...this.props.columns]
                if(this.props.columns.includes(column)){
                    const index = selectedColumns.indexOf(column);
                    selectedColumns.splice(index, 1);
                } else {
                    selectedColumns.push(column)
                }
                this.props.toggleColumn(column)
                const columns = {
                    viewed: Boolean(selectedColumns.includes('viewed')),
                    favorite: Boolean(selectedColumns.includes('favorite')),
                    invitation: Boolean(selectedColumns.includes('invitation')),
                    application: Boolean(selectedColumns.includes('application')),
                    type: Boolean(selectedColumns.includes('type')),
                    region: Boolean(selectedColumns.includes('region')),
                    price: Boolean(selectedColumns.includes('price')),
                    opening_finish_date: Boolean(selectedColumns.includes('opening_finish_date')),
                    products: Boolean(selectedColumns.includes('products')),
                    organizator: Boolean(selectedColumns.includes('organizator')),
                    title: Boolean(selectedColumns.includes('title')),
                    password: Boolean(selectedColumns.includes('password')),
                }
                this.$client.post('add/tenders/table/config', columns).then((response) => {
                    console.log(response)
                })
            }
        }
    }
</script>